export function buildCancelUrl(returnUrl: string | null): string {
  return `${location.origin}/app/billing/cancel${returnUrl ? `?returnUrl=${encodeURIComponent(returnUrl)}` : ""}`;
}

export function buildSuccessUrl(returnUrl: string | null): string {
  return (
    `${location.origin}/app/billing/success` +
    `?checkoutSessionId={CHECKOUT_SESSION_ID}` + // this is a special template variable that gets filled in by stripe
    `${returnUrl ? `&returnUrl=${encodeURIComponent(returnUrl)}` : ""}`
  );
}

export function buildResubscribeUrl(returnUrl: string | null): string {
  return `${location.origin}/app/billing/resubscribe${returnUrl ? `?returnUrl=${encodeURIComponent(returnUrl)}` : ""}`;
}

export function buildUpgradeUrl(returnUrl: string | null): string {
  return `${location.origin}/app/billing/upgrade${returnUrl ? `?returnUrl=${encodeURIComponent(returnUrl)}` : ""}`;
}
